const popupStyles = {
    overlay: {
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    popup: {
        backgroundColor: "#fff",
        padding: "20px 30px",
        borderRadius: "8px",
        textAlign: "center",
        maxWidth: "400px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    },
};

export default popupStyles;
